/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  FetchNewsfeedFilterPayload, GetNewsfeedResponse, INewsfeedModalForm, NewsfeedState,
} from 'pages/newsfeed/interface';

export const initialState: NewsfeedState = {
  loading: false,
  newsfeeds: [],
  pinnedPosts: [],
  total: 0,
  newsfeedFormData: {
    caption: '',
    mediaUrl: '',
    postType: '',
    visibility: '',
    fileType: '',
    fileCategory: '',
    name: '',
    resolve: null,
    reject: null,
  },
};

export const newsfeedSlice = createSlice({
  name: 'feature/newsfeed',
  initialState,
  reducers: {
    getNewsfeeds(state: NewsfeedState, action: PayloadAction<FetchNewsfeedFilterPayload>) {
      state.loading = true;
    },
    getNewsfeedsSucceeded(state: NewsfeedState, _action: PayloadAction<GetNewsfeedResponse>) {
      const { result, total } = _action.payload;
      state.loading = false;
      state.newsfeeds = result;
      state.total = total;
    },
    getNewsfeedsFailed(state: NewsfeedState) {
      state.loading = false;
    },
    createNewsfeed(state: NewsfeedState, action: PayloadAction<INewsfeedModalForm>) {
      state.loading = true;
      state.newsfeedFormData = action.payload;
    },
    createNewsfeedSucceeded(state: NewsfeedState) {
      state.loading = false;
    },
    createNewsfeedFailed(state: NewsfeedState) {
      state.loading = false;
    },
    deleteNewsfeedItem(state: NewsfeedState, action: PayloadAction<String>) {
      state.loading = true;
    },
    deleteNewsfeedItemSuccessed(state: NewsfeedState, action: PayloadAction<string>) {
      const temp = state.newsfeeds.filter((newsfeed) => newsfeed._id !== action.payload);
      state.newsfeeds = [...temp];
      state.loading = false;
    },
    deleteNewsfeedItemFailed(state: NewsfeedState) {
      state.loading = false;
    },
    pinNewsfeedItem(state: NewsfeedState, action: PayloadAction<String>) {
      state.loading = true;
    },
    pinNewsfeedItemSuccessed(state: NewsfeedState, action: PayloadAction<string>) {
      state.loading = false;
    },
    pinNewsfeedItemFailed(state: NewsfeedState) {
      state.loading = false;
    },
  },
});

export const { actions: newsfeedAction } = newsfeedSlice;
